import { OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'modules/core/services/admin.service';
import { ThemeService } from 'modules/shared/services/theme.service';
var TasksCardComponent = /** @class */ (function () {
    function TasksCardComponent(translateService, cdRef, themeService, adminService) {
        this.translateService = translateService;
        this.cdRef = cdRef;
        this.themeService = themeService;
        this.adminService = adminService;
        this.unsubscribe$ = new Subject();
        this.currentFilter = '';
        this.currentTable = '';
        this.pendingTasks = [];
        this.tasksChartTitle = "" + this.translateService.instant('dashboard.chart.title.task');
        this.donutChartColorPalette = {
            theme_dark: {
                chartFontColor: '#fff',
                legendFontColor: '#fff',
                legendBackgroundColor: '#0b1f2a',
                dividerColor: '#286170'
            },
            theme_light: {
                chartFontColor: '#000',
                legendFontColor: '#000',
                legendBackgroundColor: '#e7e7e7',
                dividerColor: '#bdbdbd'
            },
        };
        this.currentTheme = 'theme_dark';
    }
    Object.defineProperty(TasksCardComponent.prototype, "tasksStats", {
        set: function (stats) {
            this.donutData = [];
            if (stats) {
                this.donutData = [
                    {
                        name: "" + this.translateService.instant('dashboard.chart.title.pending_case'),
                        color1: '#0abc9e',
                        color2: '#65e0cb',
                        value: stats.pendingTaskCount
                    }, {
                        name: "" + this.translateService.instant('dashboard.chart.title.overdue_case'),
                        color1: '#e6365d',
                        color2: '#e65876',
                        value: stats.overdueTaskCount
                    }, {
                        name: "" + this.translateService.instant('dashboard.chart.title.periodic_review'),
                        color1: '#1c8bb4',
                        color2: '#52c3cb',
                        value: stats.ongoingDueDiligenceCount
                    }, {
                        name: "" + this.translateService.instant('dashboard.chart.title.expiring_document'),
                        color1: '#ffb744',
                        color2: '#ffdfaa',
                        value: stats.expiringDocCount
                    }
                ];
            }
            this.cdRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    TasksCardComponent.prototype.ngOnInit = function () {
        this.overdueTaskPeriod$ = this.adminService
            .getConfig('OVERDUE_TASK_PERIOD')
            .pipe(takeUntil(this.unsubscribe$), map(function (overdueCase) { return overdueCase; }), catchError(function () { return of({ key: 'OVERDUE_TASK_PERIOD', value: 14 }); }));
    };
    TasksCardComponent.prototype.ngAfterViewInit = function () {
        this.checkCurrentTheme();
    };
    TasksCardComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * @method checkCurrentTheme
     * Check current theme (light or dark)
     */
    TasksCardComponent.prototype.checkCurrentTheme = function () {
        var _this = this;
        this.themeService
            .getTheme()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (currentTheme) {
            if (currentTheme) {
                _this.currentTheme = currentTheme;
                _this.cdRef.detectChanges();
            }
        });
    };
    /**
     * Filter table or open corresponding page when user click on chart
     * @method onSelectHandler
     */
    TasksCardComponent.prototype.onSelectHandler = function (event) {
        if (event) {
            this.currentFilter = event.name;
            switch (event.name) {
                case "" + this.translateService.instant('dashboard.chart.title.pending_case'):
                    this.currentTable = 'Pending Task Table';
                    break;
                case "" + this.translateService.instant('dashboard.chart.title.overdue_case'):
                    this.currentTable = 'Overdue Task Table';
                    break;
                case "" + this.translateService.instant('dashboard.chart.title.expiring_document'):
                    this.currentTable = 'Expiring Document Table';
                    break;
                case "" + this.translateService.instant('dashboard.chart.title.periodic_review'):
                    this.currentTable = 'Periodic Review Table';
                    break;
                default:
                    this.currentTable = '';
                    break;
            }
        }
        else {
            this.currentTable = '';
        }
    };
    return TasksCardComponent;
}());
export { TasksCardComponent };
